
export enum ECMActionType {
    QuickStart = 'Quick Start',
    SmartPolicy = 'Smart Policy',
    PullFromExisting = 'From existing policy',
}

export enum PMActionType {
    VIEW = 'View Policy',
    EDIT = 'Update Info',
    DELETE = '',
    RESTORE = 'Restore Policy',
    PULL = 'Pull Policy',
    PUSH = 'Push Policy'
}

export enum CopyAction {
    CopyAndApply = 'Copy and Apply',
    CopyAsDraft = 'Copy as Draft'
}

export enum NotificationType {
    SUCCESS = 'success',
    INFO = 'info',
    WARNING = 'warning',
    ERROR = 'error'
}

export enum MainPages {
    POLICY = 'policy',
    INSIGHTS = 'insights',
    OVERVIEW = 'overview',
    BRONZE = 'bronze',
    POLICY_SELECTION = 'policy-selection',
    WELCOME_PAGE = 'welcome-page',
    CONNECTIONS = 'connections'
}

export enum ProtectionMenuNameOptions {
    GEO_FILTERING = 'geo-filtering',
    WEB_FILTERING = 'web-filtering',
    APPS = 'apps',
    SERVICES = 'services',
    IP_CONTROL = 'ip-control',
    PROTECTION_PLUS = 'protection-plus',
    FIREWALL_RULES = 'firewall-rules',
    Library = 'library',
}

export enum ProtectionNavigation {
    DEFAULT = 'Default',
    ADVANCED = 'Advanced'
}

export enum SortDirection {
    ASC = 'ASC',
    DESC = 'DESC',
}

export enum BulkProtectionOptions {
    WEB_FILTERING = 'web-filtering',
    GEO_FILTERING = 'geo-filtering',
    APPS = 'apps',
    SERVICES = 'services',
    ALLOW_LIST = 'ip-control-Allow List',
    BLOCK_LIST = 'ip-control-Block List',
    DOMAINS = 'web-filtering-Domains',
    PROTECTION_PLUS = 'protection-plus',
    IP_CONTROL = 'ip-control-IP Control',
}

export enum ActionType {
    ALLOW = 'Allow',
    BLOCK = 'Block',
}

export enum ServiceActionType {
    ALLOW = 'ALLOW',
    BLOCK = 'BLOCK',
    NOT_APPLY = 'NOT_APPLY'
}

export enum ProtocolType {
    TCP = 'TCP',
    UDP = 'UDP',
}

export enum BlockDirectionType {
    IS_OUTBOUND = 'isOutbound',
    IS_INBOUND = 'isInbound',
}

export enum VersionStatus {
    DRAFT = 'DRAFT',
    COMMIT_SENT = 'COMMIT_SENT',
    COMMIT_OK = 'COMMIT_OK',
    COMMIT_ERROR = 'COMMIT_ERROR',
    PUSH_SENT = 'PUSH_SENT',
    PUSH_OK = 'PUSH_OK',
    PUSH_ERROR = 'PUSH_ERROR',
}

export enum ActivationState {
    ACTIVE = 'active',
    INACTIVE = 'inactive'
}
export enum VersionState {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE'
}

export enum WebFilteringSubMenu {
    CATEGORIES = 'Categories',
    DOMAINS = 'Domains',
}

export enum IPControlSubMenu {
    ALLOW_LIST = 'Allow List',
    BLOCK_LIST = 'Block List'
}

export enum InventorySubMenu {
    ADDRESSES = 'Addresses',
    GROUPS = 'Address Groups',
    SERVICES = 'Services'
}

export const enum SavingStatus {
    Saving = 'Saving',
    Applying = 'Applying',
    Applied = 'Applied',
    Saved = 'Saved',
    Error = 'Error',
}

export enum GeoFilterNames {
    All = 'All',
    Blocked = 'Blocked',
    Allowed = 'Allowed',
    HighRiskCountries = 'High Risk Countries',
}

export enum CategoriesFilterNames {
    All = 'All',
    Blocked = 'Blocked',
    Allowed = 'Allowed',
    HighRiskCategories = 'High Risk Categories',
    AICategories = 'AI Categories',
}

export enum ServicesFilterNames {
    All = 'All',
    Blocked = 'Blocked',
    Allowed = 'Allowed',
    Default = 'Default',
    Custom = 'Custom',
    Services = 'Services',
    Applications = 'Applications',
    NOT_APPLY = 'Not Apply'
}

export enum AppsFilterNames {
    All = 'All',
    Blocked = 'Blocked',
    Allowed = 'Allowed',
    AiDefense = 'AI Defense',
}

export enum Direction {
    Inbound = 'Inbound',
    Outbound = 'Outbound',
}

export enum AppsFilter {
    AllApps = 'All',
    AiApps = 'AI apps',
}

export enum InsightsSubMenu {
    REPORTS = 'Reports',
    LOGS = 'Logs',
    ACTIVITY = 'Activity',
}

export enum DateFilterOption {
    Yesterday = 'Yesterday',
    LastWeek = 'Last Week',
    SpecificDay = 'Specific Day',
    SpecificWeek = 'Specific Week',
    Multiple = 'Multiple Dates',
}


export enum DateFilterOptionNew {
    LastTwentyFourHours = 'Last 24 hours',
    LastWeek = 'Last 7 days',
    LastMonth = 'Last 30 days'
}

export enum DirectionFilterNames {
    ALL = 'All',
    OUTBOUND = 'Outbound',
    INTBOUND = 'Inbound',
    BOTH = 'Both'
}

export enum Zone {
    MY_NETWORK = 'My Network',
    INTERNET = 'Internet',
}

export enum IPDirection {
    OUTBOUND = 'Outbound',
    INTBOUND = 'Inbound',
    BOTH = 'Both'
}

export enum AddressIPType {
    IP_NETMASK = 'Single',
    IP_RANGE = 'Range',
    IP_SUBNET = 'Subnet'
}

export enum AddressType {
    IPV4_NETMASK = 'ip-netmask',
    IPV4_RANGE = 'ip-range',
}

export enum TableMode {
    REGULAR = 'REGULAR',
    LIGHT = 'LIGHT',
    SCROLL_X = 'SCROLL_X'
}

export enum TableRowMode {
    EDIT = 'Edit',
    VIEW = 'View',
    NEW = 'New',
}

export enum LogsType {
    URL_FILTERING = 'URL',
    TRAFFIC = 'Traffic',
    THREAT = 'Threat'
}

export enum TimeRange {
    LAST_5_MINS = 'Last 5 Minutes',
    LAST_10_MINS = 'Last 10 Minutes',
    LAST_30_MINS = 'Last 30 Minutes',
    LAST_60_MINS = 'Last 60 Minutes',
    LAST_4_HOURS = 'Last 4 Hours',
    LAST_12_HOURS = 'Last 12 Hours',
    TODAY = 'Today',
    YESTERDAY = 'Yesterday',
    LAST_24_HOURS = 'Last 24 Hours',
    LAST_7_DAYS = 'Last 7 Days'
}

export enum AllowDropRuleAction {
    ALL = 'All',
    ALLOW = 'Allow',
    DROP = 'Drop'
}

export enum AlertDropRuleAction {
    ALL = 'All',
    ALERT = 'Alert',
    RESET_BOTH = 'Reset-Both'
}

export enum AlertBlockAction {
    ALL = 'All',
    ALERT = 'Alert',
    BLOCK = 'Block-Url'
}

export enum ReportName {
    Aggregate_Customer_Traffic = 'Traffic Utilization',
    NETWORK_TRAFFIC = 'App Traffic',
    TOP_SOURCSE_DENIED = 'Top Sources Denied',
    TOP_SOURCSE_ALLOWED = 'Top Sources Allowed',
    TOP_TALKERS = 'Top Talkers',
    TOP_DESTINATION_ALLOWED = 'Top Destinations Allowed',
    TOP_DESTINATION_DENIED = 'Top Destinations Denied',
    TOP_ALLOWED_URL = 'Top Allowed URLs',
    TOP_BLOCKED_URL = 'Top Blocked URLs',
    TOP_DNS_CATEGORIES_BLOCKED = 'Top DNS Categories Blocked',
    TOP_BLOCKED_DOMAINS = 'Top Blocked DNS Domains',
    TOP_URL_FILTERING_CATEGORIES_DENIED = 'Top URL Categories Blocked',
    TOP_URL_FILTERING_CATEGORIES_ALLOWED = 'Top URL Categories Allowed',
    TOP_ALLOWED_LIST_HITS = 'Top Allow List Hits',
    TOP_BLOCKED_LIST_HITS = 'Top Block List Hits',
    TOP_BLOCKED_COUNTRIES_INBOUND = 'Top Blocked Countries - Inbound',
    TOP_BLOCKED_COUNTRIES_OUTBOUND = 'Top Blocked Countries - Outbound',
    TOP_GLOBAL_BLOCK_OUTBOUND_HITS = 'Top DD Shield Outbound Hits',
    TOP_DETECTED_THREATS = 'Top Detected Threats',
    APPLICATION_HISTOGRAM = 'Application Histogram',
    AI_APPLICATION_HISTOGRAM = 'Application AI Histogram',
    EXECUTIVE_SUMMARY = 'Executive Summary',
    TOP_15_BLOCKED_APPS = 'Top blocked apps',
    TOP_15_BLOCKED_SERVICES = 'Top blocked services',
    TOP_15_ALLOWED_COUNTRIES = 'Allowed countries',
    TOP_15_BLOCKED_COUNTRIES = 'Top blocked countries',
    TOP_15_DETECTED_THREATS = 'Top detected threats',
}

export enum WidgetName {
    BLOCKED_SESSIONS_WIDGET = 'BLOCKED_SESSIONS',
    ALLOWED_SESSIONS_WIDGET = 'ALLOWED_SESSIONS',
    BLOCKED_SESSIONS_BY_TYPE_WIDGET = 'BLOCKED_SESSIONS_BY_TYPE',
    BLOCKED_COUNTRIES_WIDGET = 'BLOCKED_COUNTRIES',
    ALLOWED_COUNTRIES_WIDGET = 'ALLOWED_COUNTRIES',
    BLOCKED_THREATS_BY_SEVERITY_WIDGET = 'BLOCKED_THREATS_BY_SEVERITY',
    CRITICAL_THREATS_WIDGET = 'CRITICAL_THREATS',
    TOP_BLOCKED_DOMAINS_WIDGET = 'TOP_BLOCKED_DOMAINS',
    TOP_USED_APPS_WIDGET = 'TOP_USED_APPS',
    TOP_AI_USED_APPS_WIDGET = 'TOP_AI_USED_APPS'
}

export enum OnBoardingStatus {
    Start = 'Start',
    InProgress = 'InProgress',
    Finish = 'Finish'
}

export enum ProtectionPageName {
    GeoFiltering = 'Geo Filtering',
    WebFiltering = 'Web Filtering',
    AppsServices = 'Apps & Services',
    IPControl = 'IP Control',
    ProtectionPlus = 'Protection +'
}

export enum ProtectionPlusTitles {
    DYNAMIC_DEFENSE = 'Dynamic Defense Shield',
    ADVANCED_TREAT = 'Premium Threat Protection'
}

export enum UserPreferencesPageType {
    Report = 'reportsPage',
}

export enum UnsavedChanges {
    ROW_UNSAVED = 'row-unsaved',
    DOWNLOAD_FILE = 'download-file'
}

export enum CircuitType {
    ADI = 'ADI',
    ASEoD = 'ASEoD iEVC',
    ABF = 'ABF',
    ABF_EI = 'ABF-EI',
    AIA_B = 'AIA-B',
    MOBILE_CRU = 'MOBILE-CRU',
}

export const circuitTypeDisplayLabels: Record<CircuitType, string> = {
    [CircuitType.ADI]: CircuitType.ADI,
    [CircuitType.ASEoD]: CircuitType.ASEoD,
    [CircuitType.ABF]: CircuitType.ABF,
    [CircuitType.ABF_EI]: CircuitType.ABF_EI,
    [CircuitType.AIA_B]: CircuitType.AIA_B,
    [CircuitType.MOBILE_CRU]: 'MOBILE',
};

export const getCircuitTypeDisplayLabel = (circuitType?: string): string =>
    circuitType ? circuitTypeDisplayLabels[circuitType as CircuitType] ?? circuitType : '';

export enum LevelName {
    GOLD = 'GOLD',
    SILVER = 'SILVER',
    BRONZE = 'BRONZE'
}

export enum EditorMode {
    EDIT = 'Edit',
    NEW = 'New'
}

export enum ProtectionPlusOptions {
    BLOCK = 'Block',
    ALERT = 'Alert'
}

export enum SeverityType {
    CRITICAL = 'Critical',
    HIGH = 'High',
    MEDIUM = 'Medium',
    LOW = 'Low',
    INFO = 'Info'
}

export enum ThreatType {
    VIRUS = 'Virus',
    SPYWARE = 'Spyware',
    DNS = 'DNS',
    VULNERABILITY = 'Vulnerability'
}

export type ProtectionPlusExtraOptions = ProtectionPlusOptions | 'Manual' | 'Inactive'

export enum RuleTabs {
    GENERAL = 'General',
    SOURCE = 'Source',
    DESTINATION = 'Destination',
    SERVICES = 'Services',
    APPLICATIONS = 'Applications',
    PROFILES = 'Profiles'
}

export enum ProfilesOptions {
    INACTIVE = 'Inactive',
    BLOCK = 'Block',
    ALERT = 'Alert'
}

export enum FeatureName {
    VIRUS_PROTECTION = 'anti_virus',
    SPYWARE_PROTECTION = 'anti_spyware',
    VULNERABILITY_PROTECTION = 'vulnerability_protection',
    DNS = `dns`,
}
export enum ComponentNamesForPermission {
    AdvancedThreatProtection = 'Protection+: Premium Threat Protection',
    AppProtection = 'Dynamic Defense Protection'
}

export enum ActivityActionsSorted {
    APPLY_POLICY = 'Apply Policy',
    CREATE_DRAFT = 'Create Draft',
    DELETE_DRAFT = 'Delete Draft',
    RESTORE_POLICY = 'Restore Policy',
    CREATE_BULK_POLICY = 'Create Bulk Draft',
    APPLY_BULK_POLICY = 'Apply Bulk Policy',
    SIGN_IN = 'Sign In',
    SIGN_OUT = 'Sign Out'
}

export enum ActivityActionsRequest {
    SIGN_IN = 'sign-in',
    SIGN_OUT = 'sign-out'
}

export enum DisableReasons {
    INACTIVE_VERSION = 'inactive-version',
    DEACTIVATE_VERSION = 'deactivate-version',
    DRAFT_EXIST = 'draft-exist',
    READ_ONLY_USER = 'read-only-user',
    PENDING_EXIST = 'pending-exist',
    DNS_PROTECTION_DEACTIVATED = 'dns-protection-deactivated',
    CAN_NOT_CHANGE = 'can-not-change',
    TCP_All_OR_UDP_All = 'tcp-or-udp-max-ports',
    PULL_NOT_AVAILABLE_PENDING = 'pull-not-available-pending',
    PULL_NOT_AVAILABLE_BASE_VERSION = 'pull-not-available-base-version',
    PULL_NOT_AVAILABLE_FROM_DEACTIVATED = 'pull-not-available-deactivated',
    PUSH_NOT_AVAILABLE_PENDING = 'push-not-available-pending',
    PUSH_NOT_AVAILABLE_DRAFT_VERSION = 'push-not-available-draft-version',
    PUSH_NOT_AVAILABLE_FROM_DEACTIVATED = 'push-not-available-deactivated',
    PUSH_NOT_AVAILABLE_BASE_VERSION = 'push-not-available-base-version',
    RESTORE_NOT_AVAILABLE_FROM_DEACTIVATED = 'restore-not-available-deactivated',
    SCHEDULED_VERSION_COME_ON = 'scheduled-version-come-on',
    SCHEDULED_VERSION_EXITS = 'scheduled-version-exits',
    CREATE_DRAFT_NOT_AVAILABLE_DEACTIVATED = 'create-draft-not-available-deactivated',
    MAX_LOG_FOR_LOCAL_DOWNLOAD = 'max-log-for-local-download',
    SMART_DRAFT_IN_PROGRESS = 'smart-draft-in-progress'
}

export enum AlertTypes {
    DRAFT_EXIST = 'draft-exist',
    READ_ONLY_USER = 'read-only-user',
    ERROR = 'fw-service-error',
    MAINTENANCE = 'maintenance-activity',
    EXPORT_ALL_RECORDS = 'export-all-records',
    SMART_PROTECTION = 'smart-protection',
    CUSTOM_PROTECTION = 'custom-protection',
    PULL_PROTECTION = 'pull-protection',
    DEACTIVATED_VERSION = 'deactivated-version',
    SCHEDULED_VERSION_COME_ON = 'scheduled-version-come-on',
}

export enum StatusBadgeOptions {
    INACTIVE = 'inactive',
    INBOUND_INACTIVE = 'inbound inactive',
    OUTBOUND_INACTIVE = 'outbound inactive',
    PARTIALLY_INACTIVE = 'partially inactive',
    ATT_RECOMMENDED = 'at&t recommended',
    CUSTOM = 'custom'
}

export enum ApplicationsDefaultBehavior {
    BLOCK_ALL = 'BLOCK_ALL',
    ALLOW_ALL = 'ALLOW_ALL'
}

export enum PolicyMode {
    QUICK_START = 'QUICK_START',
    SMART_POLICY = 'SMART_POLICY',
    CUSTOM_PROTECTION = 'CUSTOM_PROTECTION',
    PULL_POLICY = 'PULL_POLICY',
    UNDEFINED = 'UNDEFINED'
}

export enum SmartPolicyTaskStatus {
    PENDING = 'PENDING',
    IN_PROGRESS = 'IN_PROGRESS',
    COMPLETED = 'COMPLETED',
    CANCELED = 'CANCELED',
    ERROR = 'ERROR'
}

export enum CancelSmartPolicyOutcome {
    CANCELED = 'CANCELED',
    FAILED = 'FAILED'
}

export enum VersionLabel {
    Active = 'Active',
    Draft = 'Draft',
    Pending = 'Pending',
    Validated = 'Validated',
    Inactive = 'Inactive',
    Initial = 'Initial',
}

export enum IPType {
    IPV4 = 'IPV4',
    IPV6 = 'IPV6',
}

export enum PolicyType {
    DEACTIVATE = 'DEACTIVATE',
    REACTIVATE = 'REACTIVATE',
    DNS_DEACTIVATE = 'DNS_OFF',
    SMART_POLICY = 'SMART_POLICY',
    DEFAULT = 'DEFAULT',
}

type EnumRecord<T> = {
    [K in keyof T]: T[K];
};

export const getEnumOptions = <T extends EnumRecord<T>>(enumType: T): Array<{ value: string; label: string }> => {
    return Object.values(enumType).map((value: any) => ({ value, label: value }));
};

export const getCustomEnumOptions = <T extends EnumRecord<T>>(
    enumType: T,
    excludedValue?: string)
    : Array<{ value: string; label: string }> => {

    return Object.values(enumType).filter(v => v !== excludedValue)
        .map((value: any) => ({ value, label: value }));
};

export enum BronzeVersionState {
    DRAFT = 'Draft',
    APPLY = 'Apply',
    SAVING = 'Saving',
    PENDING = 'Pending',
    APPLIED = 'Applied'
}